import { normalizePreloader } from "@/lib/preloaders";

const HOST_KEY = "ms_host_v1";

function readJson(key) {
  try {
    return JSON.parse(sessionStorage.getItem(key) || "null");
  } catch {
    return null;
  }
}

export function readHostCache(host) {
  const all = readJson(HOST_KEY);
  const row = all && host ? all[host] : null;
  if (!row || !row.slug) return null;
  return { slug: String(row.slug), preloader: normalizePreloader(row.preloader) };
}

export function writeHostCache(host, slug, preloader) {
  if (!host) return;
  try {
    const all = readJson(HOST_KEY) || {};
    if (slug) all[host] = { slug, preloader: normalizePreloader(preloader) };
    else delete all[host];
    sessionStorage.setItem(HOST_KEY, JSON.stringify(all));
  } catch { /* private mode */ }
}

export function bootStore() {
  try {
    const row = window.__MS_STORE__;
    if (row && row.slug) return { slug: String(row.slug), preloader: normalizePreloader(row.preloader) };
  } catch { /* ignore */ }
  return null;
}

export function readStoreConfig(slug) {
  if (!slug) return null;
  const data = readJson(`ms_cfg_${slug}`);
  if (!data || data.tenant?.slug !== slug) return null;
  return data;
}

export function writeStoreConfig(slug, data) {
  if (!slug || !data) return;
  try {
    sessionStorage.setItem(`ms_cfg_${slug}`, JSON.stringify(data));
  } catch { /* quota */ }
}
